export default __webpack_public_path__ + "static/media/signin.9cdb60bb.svg";